// src/components/strumenti/MediaValori.js — W442. Media semplice o ponderata di un elenco di valori
import React from "react";
import { useCampi, Testo, Risultato, Formula, Azzera, Avviso, fmt } from "./UiStrumento";
import { media } from "../../utils/calcoliStrumenti";
import { leggiNumero } from "../../utils/numeriStrumenti";

/** Una riga per valore: «valore» oppure «valore ; peso» (anche con la tabulazione, incollando da Excel). */
export function righeMedia(testo) {
  const righe = String(testo || "").split("\n").map(r => r.trim()).filter(Boolean);
  const out = [], errate = [];
  righe.forEach((r, i) => {
    const [a, b] = r.split(/[;\t]/);
    const valore = leggiNumero(a);
    const peso = b !== undefined && b.trim() !== "" ? leggiNumero(b) : undefined;
    if (!Number.isFinite(valore) || (peso !== undefined && !Number.isFinite(peso))) errate.push(i + 1);
    else out.push({ valore, peso });
  });
  return { righe: out, errate };
}

export default function MediaValori() {
  const { v, set, azzera } = useCampi({ testo:"" });
  const { righe, errate } = righeMedia(v.testo);
  const pesati = righe.filter(r => r.peso !== undefined).length;
  const misto = pesati > 0 && pesati < righe.length;
  const r = misto ? null : media(righe);
  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <Testo etichetta="Valori, uno per riga" valore={v.testo} onChange={set("testo")} placeholder={"Es. media semplice:\n7,5\n8\n6,5\n\nMedia ponderata: valore ; peso\n120 ; 3\n95 ; 1"} righe={6} aiuto="Per la media ponderata scrivi «valore ; peso» su ogni riga (si possono incollare due colonne da Excel)."/>
      </div>
      {errate.length > 0 && <Avviso>Righe non lette (non sono numeri): {errate.join(", ")}.</Avviso>}
      {misto && <Avviso>Il peso c'è solo su alcune righe: scrivilo su tutte (media ponderata) o su nessuna (media semplice).</Avviso>}
      <Risultato settore="matematica" titolo={r?.ponderata ? "Media ponderata" : "Media"} valore={fmt(r?.media, 4)}
        righe={r ? [["Valori considerati", String(r.n)], r.ponderata && ["Somma dei pesi", fmt(r.sommaPesi, 4)], ["Minimo / massimo", `${fmt(Math.min(...righe.map(x => x.valore)), 4)} / ${fmt(Math.max(...righe.map(x => x.valore)), 4)}`]] : []}/>
      <Formula>Media semplice = Σ valori ÷ n. Media ponderata = Σ (valore × peso) ÷ Σ pesi (pesi non negativi, somma maggiore di zero).</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
